export type DockPanelConfig = {
  id: string;
  title: string;
  component: string;
};

type DockPanel = {
  focus: () => void;
};

export type DockPanelApi = {
  panels: unknown[];
  getPanel: (id: string) => DockPanel | undefined;
  addPanel: (config: DockPanelConfig) => unknown;
};

const panelMap: Record<string, DockPanelConfig> = {
  "/dashboard": { id: "dashboard", title: "Dashboard", component: "dashboard" },
  "/users": { id: "users", title: "Users", component: "users" },
  "/specialists": {
    id: "specialists",
    title: "Specialists",
    component: "specialists",
  },
  "/review-specialists": {
    id: "review-specialists",
    title: "Review specialists",
    component: "review-specialists",
  },
  "/sessions": { id: "sessions", title: "Sessions", component: "sessions" },
  "/companies": { id: "companies", title: "Companies", component: "companies" },
  "/flexpass": { id: "flexpass", title: "Flexpass", component: "flexpass" },
  "/posts": { id: "posts", title: "Posts", component: "posts" },
  "/chat": { id: "chat", title: "Chat", component: "chat" },
  "/certificates": {
    id: "certificates",
    title: "Certificates",
    component: "certificates",
  },
  "/other-settings": {
    id: "other-settings",
    title: "Other settings",
    component: "other-settings",
  },
  "/withdrawals": {
    id: "withdrawals",
    title: "Withdrawals",
    component: "withdrawals",
  },
  "/session-packages": {
    id: "session-packages",
    title: "Session packages",
    component: "session-packages",
  },
  "/metadata": { id: "metadata", title: "Metadata", component: "metadata" },
  "/webinars": { id: "webinars", title: "Webinars", component: "webinars" },
  "/courses": { id: "courses", title: "Courses", component: "courses" },
  "/publications": {
    id: "publications",
    title: "Publications",
    component: "publications",
  },
  "/educational-hubs": {
    id: "educationalHubs",
    title: "EducationalHubs",
    component: "educationalHubs",
  },
  "/system-quizzes": {
    id: "systemQuizzes",
    title: "SystemQuizzes",
    component: "systemQuizzes",
  },
};

const projectFormRoutePattern =
  /^\/companies\/[^/]+\/projects\/(?:new|[^/]+\/edit)$/;
const systemQuizDesignerRoutePattern =
  /^\/system-quizzes\/(?:new|[^/]+\/edit)$/;

export const getPanelConfig = (path: string): DockPanelConfig | null => {
  if (projectFormRoutePattern.test(path)) {
    return {
      id: path.slice(1),
      title: path.endsWith("/new") ? "Create Project" : "Edit Project",
      component: "projectForm",
    };
  }

  if (systemQuizDesignerRoutePattern.test(path)) {
    return {
      id: path.slice(1),
      title: path.endsWith("/new")
        ? "Create System Quiz"
        : "Edit System Quiz",
      component: "systemQuizDesigner",
    };
  }

  return panelMap[path] ?? null;
};

export const openOrFocusRoutePanel = (api: DockPanelApi, path: string) => {
  if (api.panels.length === 0) {
    api.addPanel(panelMap["/dashboard"]);
  }

  const config = getPanelConfig(path);
  if (!config) return;

  const existing = api.getPanel(config.id);
  if (existing) existing.focus();
  else api.addPanel(config);
};
